import { getGridDateOperators } from '@mui/x-data-grid-pro';

import { getFilteredOperators } from '../get-filtered-operators';

// Must match: https://github.com/mui/mui-x/blob/master/packages/x-data-grid/src/colDef/gridDateOperators.ts
export enum GridDateOperator {
  Is = 'is',
  Not = 'not',
  After = 'after',
  OnOrAfter = 'onOrAfter',
  Before = 'before',
  OnOrBefore = 'onOrBefore',
  isEmpty = 'isEmpty',
  isNotEmpty = 'isNotEmpty',
  isBetween = 'isBetween',
}

export const getFilteredGridDateOperators = (
  allowedOperators: GridDateOperator[],
  showTime?: boolean,
) => getFilteredOperators(getGridDateOperators(showTime), allowedOperators);
